import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../app/stores/PersonStore";
import PersonActions from "../app/actions/PersonActions";

class CustomButton extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.context.router.push(`/schedule/${this.props.eventId}/tickets`);
  }

  render() {
    return (
      <div
        onClick={this.onClick}
        dangerouslySetInnerHTML={{ __html: this.props.innerHTML }}
      />
    );
  }
}

export default CustomButton;



// WEBPACK FOOTER //
// ./src/widget/custom-button.jsx